import { useState } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { PayPeriodOverview } from '@/common/components/pay-period-overview/PayPeriodOverview'
import { useManagerTimesheetSummary } from '@/common/hooks/useManagerTimesheets'
import { downloadTimesheetsCsv } from '@/common/hooks/useApprovals'
import { Button } from '@/common/components/button'
import type { EmployeeTimesheetStatus, AdminPayPeriodDetail } from '@/common/hooks/useAdminTimesheetSummary'

function ManagerTimesheets() {
  const navigate = useNavigate()
  const [exporting, setExporting] = useState(false)

  const handleEmployeeClick = (emp: EmployeeTimesheetStatus) => {
    if (emp.timesheet_id) {
      navigate({ to: '/manager/review/$timesheetId', params: { timesheetId: String(emp.timesheet_id) } })
    }
  }

  const handleExport = async (payPeriod: AdminPayPeriodDetail) => {
    setExporting(true)
    try {
      await downloadTimesheetsCsv(payPeriod.id)
    } catch {
      // download triggers browser save dialog; errors are unlikely
    } finally {
      setExporting(false)
    }
  }

  return (
    <PayPeriodOverview
      title="Team Timesheets"
      useData={useManagerTimesheetSummary}
      enableGrouping={false}
      onEmployeeClick={handleEmployeeClick}
      renderActions={(payPeriod) => (
        <div style={{ marginBottom: 16 }}>
          <Button variant="outline" size="sm" onClick={() => handleExport(payPeriod)} disabled={exporting}>
            {exporting ? 'Exporting...' : 'Export CSV'}
          </Button>
        </div>
      )}
    />
  )
}

export const Route = createFileRoute('/manager/timesheets')({
  component: ManagerTimesheets,
})
